const CHANNEL_NAME = 'cenorion.auth';

export type AuthMessage = { type: 'logout' };

/**
 * Cross-tab coordination via BroadcastChannel for the one event localStorage cannot express:
 * an explicit logout, which sibling tabs must act on immediately rather than on next load.
 */
function createChannel(): BroadcastChannel | null {
  try {
    return typeof BroadcastChannel === 'function' ? new BroadcastChannel(CHANNEL_NAME) : null;
  } catch {
    return null;
  }
}

const channel = createChannel();

export function publishAuthMessage(message: AuthMessage): void {
  channel?.postMessage(message);
}

export function subscribeToAuthMessages(handler: (message: AuthMessage) => void): () => void {
  if (!channel) return () => undefined;
  const listener = (event: MessageEvent<AuthMessage>) => handler(event.data);
  channel.addEventListener('message', listener);
  return () => channel.removeEventListener('message', listener);
}
